import { GET_AUDIENCE_EXPORT_HISTORY } from '../queries';
import { useQuery } from '@apollo/client';

const useAudienceExportHistory = ({ audienceIds }) => {
  const { loading, error, data, refetch } = useQuery(
    GET_AUDIENCE_EXPORT_HISTORY,
    {
      variables: {
        audienceIds: audienceIds || [],
      },
      skip: !audienceIds || audienceIds.length === 0, // Skip query if no audience IDs
      errorPolicy: 'all', // Return partial data even if there are errors
      notifyOnNetworkStatusChange: true, // Notify when network status changes
    }
  );

  return {
    loading,
    error,
    exportHistory: data?.audienceExportHistory || [],
    refetch,
  };
};

export default useAudienceExportHistory;
